module.exports = __webpack_public_path__ + "img/network_security-375.2e61d0d9.jpg";